import { render, staticRenderFns } from "./CardBox.vue?vue&type=template&id=31ef5b74&scoped=true"
import script from "./CardBox.vue?vue&type=script&lang=js"
export * from "./CardBox.vue?vue&type=script&lang=js"
import style0 from "./CardBox.vue?vue&type=style&index=0&id=31ef5b74&prod&scoped=true&lang=css"
import style1 from "./CardBox.vue?vue&type=style&index=1&id=31ef5b74&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef5b74",
  null
  
)

export default component.exports